import {classNames, React, observer, Highlighter} from '@api'
import {EMPTY_FUNCTION} from '@modules/common'
import { IMappedCatalogItemData, useCatalogItemsListStore } from './'
import * as css from './CatalogItemsListChip.css'
import { Chip } from '@material-ui/core'
import { UNASSIGNED } from '@constants'
import {AnchorButton} from '@blueprintjs/core'

export const CatalogItemsListChip = observer<{ count?: number, draggable?: boolean, className?: string, searchWords?: string[], data?: IMappedCatalogItemData, onDelete?: (id) => (e) => void, onClickChip?: (id) => (e) => void }>(
  function CatalogItemsListChip({count, draggable, className, data, searchWords, data: { description,title }, onDelete, onClickChip }) {
  const store = useCatalogItemsListStore(),
    id = data._id ?? data.id,
    name = description || title || data.name
  return true ? <Chip
    className={classNames(css.chip, className,{[css.chipHover]: store?.isEditMode && id !== UNASSIGNED})}
    draggable={draggable}
    classes={{label: css.label}}
    label={<div className={css.labelAndCount}>
      {searchWords?.length ? <Highlighter searchWords={searchWords} textToHighlight={name.toString()} /> : name}
      {_.isNumber(count) && count !== 0 && <span className={css.count}>({count})</span>}
    </div>}
    onDelete={onDelete ? onDelete(id) : undefined}
    onClick={onClickChip ? onClickChip(id) : draggable ? EMPTY_FUNCTION : undefined} // Hook a function here if draggable to pick up mouse over background change
  /> : <AnchorButton className={classNames(css.chip, className, {[css.chipHover]: store?.isEditMode && id !== UNASSIGNED})}
                     draggable={draggable}
                     text={searchWords?.length ? <Highlighter searchWords={searchWords} textToHighlight={name.toString()}/> : name}
                     onClick={onClickChip ? onClickChip(id) : draggable ? EMPTY_FUNCTION : undefined}
  />
})


// WEBPACK FOOTER //
// ./src/modules/catalog/sidebar/CatalogItemsList/CatalogItemsListChip.tsx